'use client' // Error components must be Client Components
import { useEffect } from 'react'
import { cookie, DY_COOKIE_SESSION } from '@/utils'

export default function Error({ error }: {
  error: Error & { digest?: string }
}) {

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  useEffect(() => {
    cookie.remove(DY_COOKIE_SESSION)
  }, [])

  return (
    <div className='global-err'>
      <hgroup>
        <h1>La página que buscas no existe</h1>
        <p>Puedes <a href={`https://${process.env.NEXT_PUBLIC_PROJECT_HOSTNAME}`}>volver al inicio</a></p>
      </hgroup>
    </div>
  )
}
